import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm } from 'redux-form';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';
import { toastr } from 'react-redux-toastr';

class UnLinkedImyStructure extends Component {
  static propTypes = {
    storeAccount: PropTypes.shape().isRequired,
    onConfirmImyStructureLink: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      targetWhsLinkAccount: null
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    const { targetWhsLinkAccount } = this.state;
    const { onConfirmImyStructureLink } = this.props;

    if (!targetWhsLinkAccount || !targetWhsLinkAccount.id) {
      toastr.error('', 'Please provide an Account Id');
    }

    onConfirmImyStructureLink(targetWhsLinkAccount);
    this.setState({ targetWhsLinkAccount: null });
  }

  setWhsAccount = value => this.setState({ targetWhsLinkAccount: value });

  render() {
    const { targetWhsLinkAccount } = this.state;
    const { storeAccount } = this.props;
    return (
      <form onSubmit={ this.handleSubmit }>
        <div className="col-8 d-inline-flex" style={ { alignItems: 'center' } }>
          <div className="col-6 mr-10">
            <AutoCompleteInput
              id="whs-account"
              name="whsAccountId"
              category="whsAccount"
              context={ { type: 'whsAccount', id: parseInt(storeAccount.id, 10), value: '' } }
              placeholder="Enter account id or number..."
              className="formSelect"
              value={ targetWhsLinkAccount || '' }
              onSelectedItem={ value => this.setWhsAccount(value) }
              onChange={ e => this.setWhsAccount(null) }
            />
          </div>
          { targetWhsLinkAccount && targetWhsLinkAccount.topLevelCustomerName && <span className="mr-10"><b>Intermediary name:</b> { targetWhsLinkAccount.topLevelCustomerName }</span>}
          <button
            type="submit"
            className="btn btn-primary"
            disabled={ !targetWhsLinkAccount }
          >
            Link Account
          </button>
        </div>
        <p className="mt-10"><b>By linking, any forms that are present on this account will be expired.</b></p>
      </form>
    );
  }
}

const UnLinkedImyStructureReduxForm = reduxForm({
  form: 'link-imy-structure'
})(UnLinkedImyStructure);

export default UnLinkedImyStructureReduxForm;
